import { GenericColumnBuilder } from './GenericColumnBuilder.js';

export class GenericRowBuilder {
    constructor() {
        this.columns = [];
        this.rowGap = null;
    }

    withRowGap(gap) {
        this.rowGap = gap;
        return this;
    }

    column(width, callback) {
        if (typeof width === 'function') {
            callback = width;
            width = undefined;
        }
        const builder = new GenericColumnBuilder(width);
        if (typeof callback === 'function') callback(builder);
        this.columns.push(builder.build());
        return this;
    }

    addColumn(width, callback) {
        return this.column(width, callback);
    }

    build() {
        return {
            columns: this.columns,
            rowGap: this.rowGap
        };
    }
}
